// extracted by mini-css-extract-plugin
export var menuItem = "t_tl d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "t_tm d_Z d_bz d_bP";
export var menuMainLink = "t_tn d_f0 d_dB";
export var menuLink = "t_tp d_f0 d_dB";
export var icon = "t_p9 d_bC d_bP";
export var divider = "t_tq d_bC d_bP";
export var sublinks = "t_tr";
export var link = "t_mC";
export var Link = "t_rz q_rz q_qN q_q6";